export const space = {
  "_10": '0.125rem',
  "_100": '0.25rem',
  "_150": '0.375rem',
  "_200": '0.5rem',
  "_300": '0.75rem',
  "_350": '0.85rem',
  "_400": '1rem',
  "_450": '1.25rem',
  "_500": '1.5rem',
  "_600": '2rem',
  "_650": '2.5rem',
  "_700": '3rem',
  "_750": '3.25rem',
  "_800": '4rem',
  "_900": '6rem',
  "_1000": '8rem',
  "_1050": '8.5rem',
  "_1100": '12rem',
  "_1150": '14.5rem',
  "_1200": '16rem',
  "_1250": '22.5rem',
  "_1300": '24rem',
  "_1400": '32rem',
  "_1500": '40rem',
  "_1600": '48rem',
}